import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import './Booking.component.scss';
import crownStill from '../../assets/images/hash-still.png';

import AppContext from '../../context/app/app.context';
import { _bookingTypes } from '../../constants/booking-types';
import { _VENUE_HIRE_DATA, _venueHireMapBg } from '../../constants/venue-hire-content';
import { _MUSIC_STUDIO_CONTENT } from '../../constants/music-studio-content';
import Regexp from '../../constants/regexp';

import { getBasketItems, addToBasket, getSlotList, removeToBasket, getMusicStudioSlotList } from '../../services/booking.service';
import { bookingSlotDate, bookingSlotDateMin, musicStudioDateOptionFormat } from '../../services/utils.service';
import { isUserLoggedIn } from '../../services/user.service';
import { getOrder } from '../../services/order.service';
import musicStudioService from '../../services/music-studio.service';
import musicStudioEnquiryService from '../../services/music-studio-enquiry.service';
import { downloadBrochure } from '../../services/venue-enquire.service';


function Booking() {

    const _peakStartHour = 17, _peakStartMinute = 0;

    const { appConfig, openModal, clickCallback, setClickCallback } = useContext(AppContext);
    const location = useLocation();
    const navigate = useNavigate();
    const [encodeKey, setEncodeKey] = useState();
    const _subMenuList = [
        { id: 'pitch', label: 'Pitch' },
        { id: 'music_studio', label: 'Music Studio' },
        { id: 'games_room', label: 'Games Room' },
        { id: 'venue_hire', label: 'Venue Hire' }
    ];
    const [selectedBookingType, setSelectedBookingType] = useState(location.state || 'pitch');

    const [selectedBooking, setSelectedBooking] = useState();
    const [gridLayoutSetting, setGridLayoutSetting] = useState({
        gridSize: 0,
        isWithBasket: true
    });
    const [togglePitchFilter, setTogglePitchFilter] = useState(false);
    const [pitchFilterList] = useState([
        {
            name: 'full_pitch',
            label: 'full pitch'
        },
        {
            name: 'half_pitch',
            label: 'half pitch'
        },
        {
            name: 'third_pitch',
            label: 'third pitch'
        }
    ]);
    const [selectedPitchType, setSelectedPitchType] = useState(pitchFilterList[0].name);
    const [slotList, setSlotList] = useState([]);
    const [slotConfig, setSlotConfig] = useState();
    const [myBasket, setMyBasket] = useState({ list: [], total: 0 });
    const [isBasketMViewShow, setIsBasketMViewShow] = useState(false);


    /** component will-mount */
    useEffect(() => {
        window.scrollTo(0, 0);
        const bookingObj = _bookingTypes.find((item) => item.type === selectedBookingType);
        setSelectedBooking(bookingObj);
        setEncodeKey(`${window.screen.height}${window.screen.width}${window.screen.colorDepth}${new Date().getTime()}`);
        getMusicStudioSubAssetList();
        // eslint-disable-next-line
    }, []);

    const resizeCallback = () => {
        /** for slots and basket layout
         * 1-Grid with screen size 0px to 679px, without basket
         * */
        setGridLayoutSetting((previousValue) => {
            if (window.innerWidth <= 679) {
                if (previousValue.gridSize !== 1 || previousValue.isWithBasket !== false) {
                    previousValue = { gridSize: 1, isWithBasket: false };
                }
                /** 2-Grid with screen size between 680px to 768px, without basket */
            } else if (window.innerWidth >= 680 && window.innerWidth <= 768) {
                if (previousValue.gridSize !== 2 || previousValue.isWithBasket !== false) {
                    previousValue = { gridSize: 2, isWithBasket: false };
                }
                /** 1-Grid with screen size between 769px to 1134px, with basket */
            } else if (window.innerWidth >= 769 && window.innerWidth <= 1134) {
                if (previousValue.gridSize !== 1 || previousValue.isWithBasket !== true) {
                    previousValue = { gridSize: 1, isWithBasket: true };
                }
                /** 2-Grid with screen size between 1135px to 1429px, with basket */
            } else if (window.innerWidth >= 1135 && window.innerWidth <= 1429) {
                if (previousValue.gridSize !== 2 || previousValue.isWithBasket !== true) {
                    previousValue = { gridSize: 2, isWithBasket: true };
                }
                /** 3-Grid with screen size 1430px to up, with basket */
            } else {
                if (previousValue.gridSize !== 3 || previousValue.isWithBasket !== true) {
                    previousValue = { gridSize: 3, isWithBasket: true };
                }
            }
            return previousValue;
        });

        /** for pitch filter */
        setTogglePitchFilter((PSTogglePitchFilter) => {
            if (PSTogglePitchFilter) {
                /** 992px it is based on break point of min to max devices */
                if (window.innerWidth < 992) {
                    document.body.style.overflow = 'hidden';
                } else {
                    document.body.style.overflow = 'auto';
                }
            }
            return PSTogglePitchFilter;
        });
    }

    useEffect(() => {
        window.addEventListener('resize', resizeCallback);
        resizeCallback();
        /** this return callback function executes at when current component is unload from DOM. */
        return () => {
            window.removeEventListener('resize', resizeCallback);
        }
        // eslint-disable-next-line
    }, []);


    const APISetTimeout = useRef();
    const previousGridSize = useRef();
    useEffect(() => {
        if (slotList.length < gridLayoutSetting.gridSize) {
            /** API Call */ // console.log("API Call", gridLayoutSetting);
            previousGridSize.current = gridLayoutSetting.gridSize;
            resizeCallbackEnd();
        } else {
            if (gridLayoutSetting.gridSize !== 0 && gridLayoutSetting.gridSize !== previousGridSize.current) {
                /** Clearing the Timeout */
                clearTimeout(APISetTimeout.current);
                APISetTimeout.current = setTimeout(() => {
                    previousGridSize.current = gridLayoutSetting.gridSize;
                    resizeCallbackEnd();
                }, 1000);
            } else {
                previousGridSize.current = gridLayoutSetting.gridSize;
            }
        }
        // eslint-disable-next-line
    }, [gridLayoutSetting, togglePitchFilter]);

    /** we are getting all basket items if added in basket or if item(s) is/are available in server */
    useEffect(() => {
        if (!isUserLoggedIn() && !localStorage.getItem('sessionId')) return;

        getBasketItems().then((res) => {
            if (res.data.code === "OK") {
                const response = res.data.data;
                if (response?.list?.length) {
                    const list = [];
                    for (const item of response.list) {
                        list.push({
                            ...item,
                            previewDate: bookingSlotDate(item.date),
                            // name: item.type.replace('_', ' ').replace(/\b\w/g, (match) => match.toUpperCase())
                        });
                    }
                    myBasket.list = list;
                    myBasket.total = response.totalAmount;
                    setMyBasket({ ...myBasket });
                }
            }
        }).catch((err) => {
            console.log('Error while getting basket items', err);
        });
        // eslint-disable-next-line
    }, []);

    const getAndSetSlotList = (body, pitchTypeAdded = false) => {
        if (['music_studio', 'venue_hire'].includes(body.assetType)) {
            return;
        }

        if (body.assetType === "pitch" && !pitchTypeAdded) {
            body.pitchType = selectedPitchType.replace('_pitch', '').toUpperCase();
        }
        // console.log(body);
        getSlotList(body, encodeKey)
            .then((res) => {
                if (res.data.code === "OK") {
                    const response = res.data.data;
                    let priceType = 'full';
                    if (body.assetType === 'pitch') {
                        // pitchType come with on pitch selection change
                        priceType = body.pitchType?.toLowerCase();
                    }

                    setSlotConfig({ ...response.slotConfig });
                    const list = response.list ?? [];
                    for (const item of list) {
                        item.dDate = bookingSlotDateMin(item.date);
                        for (const slot of item.slot) {
                            // 0 sunday, 6 saturday
                            if ([0, 6].includes(new Date(item.date).getDay())) {
                                slot.price = response.slotConfig.pricing.peakPrice[priceType];
                            } else {
                                const slotStartTime = new Date(item.date);
                                slotStartTime.setHours(slot.startHs, slot.startMs, 0, 0);
                                const peakStartTime = new Date(item.date);
                                peakStartTime.setHours(_peakStartHour, _peakStartMinute, 0, 0);

                                if (slotStartTime.getTime() < peakStartTime.getTime()) {
                                    slot.price = response.slotConfig.pricing.offPeakPrice[priceType];
                                } else {
                                    slot.price = response.slotConfig.pricing.peakPrice[priceType];
                                }
                            }
                        }
                    }

                    setSlotList([...list]);
                }
            }).catch((error) => {
                console.log('Error while getting booking slots', error);
            });
    }

    const resetInputFieldValues = () => {
        document.querySelectorAll('[name^="slotLimit-"]').forEach((element) => {
            if (parseInt(element.value) > 1) {
                element.value = '01';
            }
        });
    };

    useEffect(() => {
        /** forcefully active `venue hire` menu via header menu. */
        if (clickCallback) {
            if (clickCallback?.data !== selectedBookingType) {
                onChangeBookingCategory(clickCallback?.data);
            }
            setClickCallback(null);
        }
        // eslint-disable-next-line
    }, [clickCallback]);

    const onChangeBookingCategory = (category) => {
        if (category && selectedBookingType !== category) {
            const bookingObj = _bookingTypes.find((item) => item.type === category);
            setSelectedBooking(bookingObj);
            setSelectedBookingType(category);
            slotBoundary.isPreviousSlotBtnDisabled = true;
            setSlotBoundary({ ...slotBoundary });

            if (['music_studio', 'games_room'].includes(category)) {
                resetInputFieldValues();
            }
            if (category !== 'music_studio') {
                onGoBackMusicStudio();
            }

            const body = {
                assetType: category,
                date: new Date().toISOString(),
                slotSize: gridLayoutSetting.gridSize
            };

            if (category === "pitch") {
                body.pitchType = selectedPitchType.replace('_pitch', '').toUpperCase();
                const slotStartDate = new Date(slotList[0]?.date ?? new Date());
                slotStartDate.setUTCHours(0, 0, 0, 0);
                body.date = slotStartDate.toISOString();
            }

            getAndSetSlotList(body, true);
        }
    };

    const resizeCallbackEnd = () => {
        // console.log(gridLayoutSetting);

        const body = {
            assetType: selectedBookingType,
            date: new Date().toISOString(),
            slotSize: gridLayoutSetting.gridSize
        };

        if (slotList.length) {
            if (gridLayoutSetting.gridSize < slotList.length) {
                setSlotList([...slotList.splice(0, gridLayoutSetting.gridSize)]);
                return;
            } else if (gridLayoutSetting.gridSize <= slotList.length) {
                return;
            }
            const slotStartDate = new Date(slotList[0].date);
            slotStartDate.setUTCHours(0, 0, 0, 0);
            body.date = slotStartDate.toISOString();
        }

        getAndSetSlotList(body);
    };

    const onTogglePitchFilter = () => {
        if (!togglePitchFilter) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        setTogglePitchFilter(!togglePitchFilter);
    };

    const onPitchFilterChange = (itemIndex) => {
        const currentSelection = pitchFilterList[itemIndex].name;
        if (selectedPitchType === currentSelection) return;
        setSelectedPitchType(currentSelection);

        const body = {
            assetType: selectedBookingType,
            date: new Date().toISOString(),
            slotSize: gridLayoutSetting.gridSize
        };

        if (selectedBookingType === "pitch") {
            body.pitchType = currentSelection.replace('_pitch', '').toUpperCase();
            const slotStartDate = new Date(slotList[0].date);
            slotStartDate.setUTCHours(0, 0, 0, 0);
            body.date = slotStartDate.toISOString();
        }

        getAndSetSlotList(body, true);
    };

    const [slotBoundary, setSlotBoundary] = useState({ isPreviousSlotBtnDisabled: true, isNextSlotBtnDisabled: false });
    const onPreviousGetSlot = () => {

        const previousDate = new Date(slotList[0].date);
        previousDate.setUTCHours(0, 0, 0, 0);
        previousDate.setUTCDate(previousDate.getUTCDate() - 1);
        const toDayDate = new Date(new Date().setUTCHours(0, 0, 0, 0));

        if (previousDate.getTime() < toDayDate.getTime()) {
            slotBoundary.isPreviousSlotBtnDisabled = true;
            setSlotBoundary({ ...slotBoundary });
            return;
        } else if (previousDate.getTime() === toDayDate.getTime()) {
            slotBoundary.isPreviousSlotBtnDisabled = true;
            setSlotBoundary({ ...slotBoundary });
        } else if (slotBoundary.isPreviousSlotBtnDisabled) {
            slotBoundary.isPreviousSlotBtnDisabled = false;
            setSlotBoundary({ ...slotBoundary });
        }

        if (slotBoundary.isNextSlotBtnDisabled) {
            slotBoundary.isNextSlotBtnDisabled = false;
            setSlotBoundary({ ...slotBoundary });
        }

        const body = {
            assetType: selectedBookingType,
            date: new Date(previousDate.getTime()).toISOString(),
            slotSize: gridLayoutSetting.gridSize
        };
        getAndSetSlotList(body);
    };

    const onNextGetSlot = () => {

        if (slotBoundary.isPreviousSlotBtnDisabled) {
            slotBoundary.isPreviousSlotBtnDisabled = false;
            setSlotBoundary({ ...slotBoundary });
        }
        const nextDate = new Date(slotList[0].date);
        nextDate.setUTCHours(0, 0, 0, 0);
        nextDate.setUTCDate(nextDate.getUTCDate() + 1);

        if (appConfig?.bookingDaysLimit) {
            const lastDate = new Date();
            lastDate.setUTCDate((lastDate.getUTCDate() + parseInt(appConfig?.bookingDaysLimit)) - gridLayoutSetting.gridSize);
            lastDate.setUTCHours(0, 0, 0, 0);
            if (nextDate.getTime() === lastDate.getTime()) {
                slotBoundary.isNextSlotBtnDisabled = true;
                setSlotBoundary({ ...slotBoundary });
            }
            if (nextDate.getTime() > lastDate.getTime()) {
                return;
            }
        }

        const body = {
            assetType: selectedBookingType,
            date: new Date(nextDate.getTime()).toISOString(),
            slotSize: gridLayoutSetting.gridSize
        };

        getAndSetSlotList(body);
    };

    const [isAddToBasketRequestAlive, setIsAddToBasketRequestAlive] = useState(false);
    const onAddToBasket = (slotIndex, slotItemIndex) => {
        // if (!isUserLoggedIn() || slotList[slotIndex]?.slot[slotItemIndex]?.isBooked || isAddToBasketRequestAlive || selectedBookingType === 'music_studio') return;
        if (slotList[slotIndex]?.slot[slotItemIndex]?.isBooked || isAddToBasketRequestAlive || selectedBookingType === 'music_studio') return;

        const { isBooked, availableConsoles, ...slotDetails } = slotList[slotIndex].slot[slotItemIndex];
        slotDetails.bookingType = selectedBookingType;
        slotDetails.date = slotList[slotIndex].date?.split('T')[0];

        if (selectedBookingType === 'pitch') {
            slotDetails.pitchType = selectedPitchType.replace('_pitch', '').toUpperCase();
        }

        let consoleCount = 0;
        if (selectedBookingType === 'games_room') {// selectedBookingType === 'music_studio' || 
            const qtyInput = document.getElementsByName(`slotLimit-${slotIndex}-${slotItemIndex}`);
            consoleCount = parseInt(qtyInput[0]?.value || 1);
            qtyInput[0].value = "01";
            slotDetails.consoleCount = consoleCount;
            document.getElementById(`console-label-${slotIndex}-${slotItemIndex}`).innerText = 'Console \u00A0';
        }

        // call add to basket API for pitch and games room(console) only
        onHandleAddToBasket(slotDetails, { consoleCount, slotIndex, slotItemIndex });
    };


    const onHandleAddToBasket = async (slotDetails, { consoleCount, slotIndex, slotItemIndex } = {}) => {
        setIsAddToBasketRequestAlive(true);

        return new Promise((resolve, reject) => {
            /* call an API for book the slot, if request response is OK then block the slot */
            addToBasket(slotDetails).then((res) => {
                if (res.headers.has('Session-Id')) {
                    localStorage.setItem('sessionId', res.headers.get('Session-Id'));
                }

                if (res.data.code === "OK") {
                    const response = res.data.data;
                    if (response?.isSlotBlocked) {
                        if (!slotDetails?.assetId) {
                            slotList[slotIndex].slot[slotItemIndex].isBooked = true;
                            setSlotList([...slotList]);
                        }
                    }

                    if (response?.hasOwnProperty('availableCount')) {
                        if (slotDetails.bookingType === 'music_studio') {
                            const musicStudioSubAsset = musicStudioSubAssetsConfig[slotDetails.assetId];
                            if (musicStudioSubAsset) {
                                musicStudioSubAsset.availableSeats = Math.max(0, response?.availableCount);
                                setMusicStudioSubAssetsConfig({ ...musicStudioSubAssetsConfig });
                            }
                        } else if (slotDetails.bookingType === 'games_room') {
                            slotList[slotIndex].slot[slotItemIndex].availableConsoles = Math.max(0, response?.availableCount);
                            setSlotList([...slotList]);
                        }
                    }

                    if (response?.isSlotBooked) {
                        if (slotDetails.bookingType === 'music_studio') {
                            const basketItemIndex = myBasket.list.findIndex((item) => item.type === 'MUSIC_STUDIO' && item.assetId === slotDetails.assetId);

                            if (basketItemIndex === -1) {
                                myBasket.list.push({
                                    name: slotDetails.bookingType.replace('_', ' ').replace(/\b\w/g, (match) => match.toUpperCase()),
                                    type: slotDetails.bookingType.toUpperCase(),
                                    assetId: slotDetails.assetId,
                                    peopleCount: slotDetails.peopleCount,
                                    price: parseFloat(slotDetails.price),
                                });
                            } else {
                                myBasket.list[basketItemIndex].peopleCount = parseInt(myBasket.list[basketItemIndex].peopleCount + slotDetails.peopleCount);
                            }
                            myBasket.total = myBasket.total + (slotDetails.peopleCount * slotDetails.price);
                        } else {
                            const slot = slotList[slotIndex].slot[slotItemIndex];
                            const basketItem = {
                                date: slotList[slotIndex].date,
                                previewDate: bookingSlotDate(slotList[slotIndex].date),
                                endHs: slot.endHs,
                                endMs: slot.endMs,
                                startHs: slot.startHs,
                                startMs: slot.startMs,
                                name: slotDetails.bookingType.replace('_', ' ').replace(/\b\w/g, (match) => match.toUpperCase()),
                                type: slotDetails.bookingType.toUpperCase(),
                                price: 0
                            };

                            if (slotDetails.bookingType === 'pitch') {
                                basketItem.name = selectedPitchType.replace('_', ' ').replace(/\b\w/g, (match) => match.toUpperCase());
                                basketItem.type = selectedPitchType.replace('_pitch', '').toUpperCase();
                                basketItem.price = parseFloat(slot.price?.toFixed(2));
                                myBasket.list.push(basketItem);
                                myBasket.total = myBasket.total + slot.price;

                            } else if (slotDetails.bookingType === 'games_room') {

                                const basketItemIndex = myBasket.list.findIndex((item) => item.type === basketItem.type && item.date === basketItem.date && item.startHs === basketItem.startHs && item.startMs === basketItem.startMs);
                                if (basketItemIndex === -1) {
                                    basketItem.price = parseFloat(slot.price?.toFixed(2));
                                    basketItem.consoleCount = consoleCount;
                                    myBasket.list.push(basketItem);
                                } else {
                                    myBasket.list[basketItemIndex].consoleCount = parseInt(myBasket.list[basketItemIndex].consoleCount + consoleCount);
                                }
                                myBasket.total = myBasket.total + (consoleCount * slot.price);
                            }
                        }

                        myBasket.total = parseFloat(myBasket.total?.toFixed(2));
                        setMyBasket({ ...myBasket });
                    }
                }
                setIsAddToBasketRequestAlive(false);
                resolve();
            }).catch((err) => {
                setIsAddToBasketRequestAlive(false);
                reject();
                console.log('Error while add item in basket', err);
            });
        });
    }

    const onMaxLimitPerSlotBlur = (e, availableConsoleCount = 0) => {
        const slotSize = parseInt(e.target?.value);
        if (!availableConsoleCount) {
            if (slotSize <= 0) {
                e.target.value = "01";
            } else if (slotSize > slotConfig.maxLimitPerSlot) {
                e.target.value = slotConfig.maxLimitPerSlot <= 9 ? `0${slotConfig.maxLimitPerSlot}` : slotConfig.maxLimitPerSlot;
            } else {
                e.target.value = slotSize <= 9 ? `0${slotSize}` : slotSize;
            }
        } else {
            if (slotSize <= 0) {
                e.target.value = "01";
            } else if (slotSize > availableConsoleCount) {
                e.target.value = availableConsoleCount <= 9 ? `0${availableConsoleCount}` : availableConsoleCount;
            } else {
                e.target.value = slotSize <= 9 ? `0${slotSize}` : slotSize;
            }
        }
    }

    const onChangeForInputPrefix = (e, elId) => {
        if (elId?.startsWith('people-label')) {
            document.getElementById(elId).innerText = `People${+e.target.value > 1 ? 's' : ''} \u00A0`;
        } else {
            document.getElementById(elId).innerText = `console${+e.target.value > 1 ? 's' : ''} \u00A0`;
        }
    }

    const [isRemoveToBasketRequestAlive, setIsRemoveToBasketRequestAlive] = useState(false);
    const onRemoveToBasket = (basketItemIndex) => {
        // if (isRemoveToBasketRequestAlive || !isUserLoggedIn()) return;
        if (isRemoveToBasketRequestAlive) return;

        const basketItem = myBasket.list[basketItemIndex];
        const body = {
            type: basketItem.type
        };

        if (basketItem.type === 'MUSIC_STUDIO') {
            body.assetId = basketItem.assetId;
            body.peopleCount = basketItem.peopleCount;
        } else {
            body.date = basketItem.date;
            body.startHs = basketItem.startHs;
            body.startMs = basketItem.startMs;

            if (basketItem.type === 'FULL' || basketItem.type === 'HALF' || basketItem.type === 'THIRD') {
                body.bookingType = selectedPitchType.replace('_pitch', '').toUpperCase();
            } else if (basketItem.type === 'GAMES_ROOM') {
                body.consoleCount = basketItem.consoleCount;
            }
        }


        setIsRemoveToBasketRequestAlive(true);
        removeToBasket(body).then((res) => {
            if (res.data.code === "OK") {
                const response = res.data.data;

                if (['FULL', 'HALF', 'THIRD'].includes(basketItem.type)) {// , 'MUSIC_STUDIO'
                    if (response?.hasOwnProperty('isSlotBooked')) {
                        myBasket.total = parseFloat((myBasket.total - basketItem.price)?.toFixed(2));
                        myBasket.list.splice(basketItemIndex, 1);
                        setMyBasket({ ...myBasket });
                        validateSlotList(response, basketItem);
                    }
                } else if ('MUSIC_STUDIO' === basketItem.type) {
                    if (response?.hasOwnProperty('availableCount') && response?.hasOwnProperty('isSlotBooked')) {
                        myBasket.total = parseFloat((myBasket.total - (basketItem.price * basketItem.peopleCount))?.toFixed(2));
                        myBasket.list.splice(basketItemIndex, 1);
                        setMyBasket({ ...myBasket });
                        const musicStudioSubAsset = musicStudioSubAssetsConfig[basketItem.assetId];
                        if (musicStudioSubAsset) {
                            musicStudioSubAsset.availableSeats = Math.max(0, response?.availableCount);
                            setMusicStudioSubAssetsConfig({ ...musicStudioSubAssetsConfig });
                        }
                    }
                } else if ('GAMES_ROOM' === basketItem.type) {
                    if (response?.hasOwnProperty('availableCount') && response?.hasOwnProperty('isSlotBooked')) {
                        myBasket.total = parseFloat((myBasket.total - (basketItem.price * basketItem.consoleCount))?.toFixed(2));
                        myBasket.list.splice(basketItemIndex, 1);
                        setMyBasket({ ...myBasket });
                        validateSlotList(response, basketItem);
                    }
                }
            }
            setIsRemoveToBasketRequestAlive(false);
        }).catch((err) => {
            setIsRemoveToBasketRequestAlive(false);
            console.log('Error while remove basket item', err);
        });
    }

    const validateSlotList = (response, basketItem) => {
        if (selectedBookingType !== 'pitch' && selectedBookingType?.toUpperCase() !== basketItem.type) return;
        const modifiedList = slotList.map((slots) => {
            if (slots.date === basketItem.date) {
                slots.slot.map((item) => {
                    if (item.startHs === basketItem.startHs && item.startMs === basketItem.startMs) {
                        item.isBooked = response.isSlotBooked;
                        if (basketItem.type === 'GAMES_ROOM' && selectedBookingType === 'games_room') {
                            item.availableConsoles = response.availableCount;
                        }
                    }
                    return item;
                });
            }
            return slots;
        });
        setSlotList([...modifiedList]);
    }

    // const removeBasketOnUnload = () => {
    //     if (isRemoveToBasketRequestAlive || !isUserLoggedIn() || !myBasket.list?.length) return;

    //     const basketItems = myBasket.list.map((item) => {
    //         return {
    //             date: item.date,
    //             startHs: item.startHs,
    //             startMs: item.startMs,
    //             type: item.type
    //         };
    //     });

    //     setIsRemoveToBasketRequestAlive(true);
    //     removeToBasket({ basketItems }).then((res) => {
    //         if (res.data.code === "OK") {
    //             // const response = res.data.data;
    //             // console.log(response);
    //             setIsRemoveToBasketRequestAlive(false);
    //         }
    //     }).catch((err) => {
    //         setIsRemoveToBasketRequestAlive(false);
    //         console.log('Error while remove basket item', err);
    //     });
    // }

    // const isCheckoutClicked = useRef(false);
    /** component did-mount runs at when component unload in DOM
     * remove the user's selected all items in server booking queue and release the blocked slots
    */
    // useEffect(() => {
    //     return () => {
    //         if (!isCheckoutClicked.current) {
    //             removeBasketOnUnload();
    //         }
    //     }
    //     // eslint-disable-next-line
    // }, []);

    const [isCheckoutRequestAlive, setIsCheckoutRequestAlive] = useState(false);
    const onCheckout = () => {
        if (isCheckoutRequestAlive || (!isUserLoggedIn() && !localStorage.getItem('sessionId')) || !myBasket.list?.length) return;

        const body = { basketItems: [] };
        body.basketItems = myBasket.list.map((item) => {
            if (item.type === 'MUSIC_STUDIO') {
                return { type: item.type, assetId: item.assetId };
            }

            return { type: item.type, date: item.date, startHs: item.startHs, startMs: item.startMs };
        });

        setIsCheckoutRequestAlive(true);
        getOrder(body).then((res) => {
            if (res.data.code === 'OK') {
                const response = res.data.data;
                if (response?.clientSecret) {
                    // isCheckoutClicked.current = true;
                    navigate('/checkout', {
                        state: { ...response }
                    });
                } else if (response?.blockedSlots?.length) {
                    myBasket.list = myBasket.list.filter((item) => {
                        return !response?.blockedSlots.some((blockedSlot) => {
                            return (
                                (item.date === blockedSlot.date && item.type === blockedSlot.type && item.startHs === blockedSlot.startHs && item.startMs === blockedSlot.startMs) ||
                                (item.type === 'MUSIC_STUDIO' && item.assetId === blockedSlot.assetId)
                            );
                        });
                    });

                    myBasket.total = 0;
                    for (const basketItem of myBasket.list) {
                        if (['FULL', 'HALF', 'THIRD'].includes(basketItem.type)) {
                            if (response?.hasOwnProperty('isSlotBooked')) {
                                myBasket.total += basketItem.price;
                            }
                        } else if ('MUSIC_STUDIO' === basketItem.type) {
                            myBasket.total += (basketItem.price * basketItem.peopleCount);
                        } else if ('GAMES_ROOM' === basketItem.type) {
                            myBasket.total += (basketItem.price * basketItem.consoleCount);
                        }
                    }
                    myBasket.total = parseFloat(myBasket.total?.toFixed(2));
                    setMyBasket({ ...myBasket });
                } else {
                    myBasket.total = 0;
                    myBasket.list = [];
                    setMyBasket({ ...myBasket });
                }
            }
            setIsCheckoutRequestAlive(false);
        }).catch((err) => {
            setIsCheckoutRequestAlive(false);
            console.log('Error while getting order for checkout', err);
        });
    }



    /**
     * @param {Event} $event 
     * @param {'masterclass' | 'mini_masterclass' | 'book_the_studio' | '1to1_tuition' | '1to1_tuition_adult' | ''} enquireFor 
     */
    const onVenueEnquire = ($event, enquireFor = '') => {
        $event.stopPropagation();
        if (selectedBookingType === 'venue_hire') {
            openModal('venueEnquire');
        } else if (selectedBookingType === 'music_studio') {
            setIsMusicStudioBooking(true);
            setMusicStudioBookingType(enquireFor);
            if (['masterclass', 'mini_masterclass'].includes(enquireFor)) {
                setValue('asset', enquireFor);
            } else if (['book_the_studio', '1to1_tuition', '1to1_tuition_adult'].includes(enquireFor)) {
                msFormSetValue('enquiryType', enquireFor);
            }
        }
    }

    const onDownloadBrochure = async () => {
        try {
            window.open(downloadBrochure(), '_blank');
        } catch (error) {
            console.error('Download failed:', error);
        }
    };

    const onDownloadMusicStudioBrochure = async () => {
        try {
            window.open(musicStudioService.downloadMusicStudioBrochure(), '_blank');
        } catch (error) {
            console.error('Download failed:', error);
        }
    };


    // music studio booking start
    const [isMusicStudioBooking, setIsMusicStudioBooking] = useState(false);
    const [musicStudioBookingType, setMusicStudioBookingType] = useState('');// masterclass
    const musicStudioAssetList = [
        { id: 'masterclass', label: 'Masterclass' },
        { id: 'mini_masterclass', label: 'Mini Masterclass' }
    ];
    const [musicStudioSubAssets, setMusicStudioSubAssets] = useState({});
    const [musicStudioSubAssetsConfig, setMusicStudioSubAssetsConfig] = useState({});
    const [filteredMusicStudioSubAssetList, setFilteredMusicStudioSubAssetList] = useState([]);
    const [musicStudioSlotList, setMusicStudioSlotList] = useState([]);


    const musicStudioDefaultValues = {
        asset: '',
        subAsset: ''
    };
    const { register, handleSubmit, formState: { errors, isDirty, isValid, touchedFields }, reset, setValue, watch, clearErrors } = useForm({
        mode: 'all',
        defaultValues: musicStudioDefaultValues
    });

    const getMusicStudioSubAssetList = () => {
        musicStudioService.getSubAssetList().then((res) => {
            if (res.data.code === "OK") {
                const { musicStudioAssets = [] } = res.data?.data ?? {};
                // set setMusicStudioSubAssets based on assetType
                const assets = {}, assetConfig = {};
                for (const item of musicStudioAssets) {
                    if (!assets[item.assetType]) {
                        assets[item.assetType] = [];
                    }
                    assets[item.assetType].push(item);
                    assetConfig[item._id] = item;
                }
                setMusicStudioSubAssets(assets);
                setMusicStudioSubAssetsConfig(assetConfig);
            }
        });
    };

    const watchAsset = watch('asset');
    const watchSubAsset = watch('subAsset');
    // Update the subAsset list whenever the 'asset' value changes
    useEffect(() => {
        setFilteredMusicStudioSubAssetList(musicStudioSubAssets[watchAsset] ?? []);
        setValue('subAsset', '');// Reset the subAsset value when asset changes
    }, [watchAsset]); // Dependency array ensures this runs every time 'asset' changes

    // Update the subAsset list whenever the 'subAsset' value changes
    useEffect(() => {
        if (watchSubAsset) {
            const body = {
                assetId: watchSubAsset
            };
            getSlotListForMusicStudio(body);
            // reset the selected `number of guests` when asset and date are changes
            setValue('numberOfSeats', '');
            clearErrors('numberOfSeats');
        }
    }, [watchSubAsset]); //[watchSubAsset, watchDate] Dependency array ensures this runs every time 'subAsset' changes

    const getSlotListForMusicStudio = (body) => {
        getMusicStudioSlotList(body, encodeKey).then((res) => {
            if (res.data.code === 'OK') {
                const { list = [], availableSeats = 0 } = res.data.data;
                const musicStudioSubAsset = musicStudioSubAssetsConfig?.[body.assetId];
                if (musicStudioSubAsset) {
                    musicStudioSubAsset.availableSeats = availableSeats;
                    setMusicStudioSubAssetsConfig({ ...musicStudioSubAssetsConfig });
                }

                for (const item of list) {
                    item.date = item.date.split('T')[0];
                    item.dDate = musicStudioDateOptionFormat(item.date);
                    item.slotCount = item.slots.length > 1;
                    item.slots.forEach((slot) => {
                        slot.startHours = slot.startHours.toString().padStart(2, '0');
                        slot.startMinutes = slot.startMinutes.toString().padStart(2, '0');
                        slot.endHours = slot.endHours.toString().padStart(2, '0');
                        slot.endMinutes = slot.endMinutes.toString().padStart(2, '0');
                    });
                }
                setMusicStudioSlotList([...list]);
            }
        }).catch((error) => {
            console.log('Error while getting booking slots', error);
        });
    };


    const onAddToBasketMusicStudio = (data, e) => {
        e?.preventDefault();
        try {
            if (!isValid || !isDirty || isAddToBasketRequestAlive) {
                return;
            } else {
                const body = {
                    assetId: data.subAsset,
                    bookingType: selectedBookingType,// music_studio
                    price: musicStudioSubAssetsConfig[data.subAsset].price,// price
                    peopleCount: parseInt(data.numberOfSeats, 10),// peopleCount
                };
                onHandleAddToBasket(body).then(() => {
                    setValue('numberOfSeats', '');
                    clearErrors('numberOfSeats');
                }).catch((err) => {
                    console.error('Error while adding music studio slot to basket', err);
                });
            }
        } catch (err) {
            console.error(`Error while submitting form`, err);
        }
    }


    const onGoBackMusicStudio = (e = null) => {
        e?.stopPropagation();
        setIsMusicStudioBooking(false);
        setMusicStudioBookingType('');
        setMusicStudioSlotList([]);
        reset({ ...musicStudioFormDefaultValues });
    }
    // music studio booking end


    /** fields based on `enquiryType`
     * 1to1_tuition_adult: 'name', 'email', 'phoneNo', 'shortDescription', 'enquiryType'
     * 1to1_tuition: 'studentName', 'name', 'email', 'phoneNo', 'shortDescription', 'enquiryType', 'wouldParentLikeToAttend'
     * book_the_studio: 'name', 'email', 'phoneNo', 'shortDescription', 'enquiryType', 'hasUsedStudioBefore', 'requiresEngineer'
     */
    const musicStudioFormDefaultValues = {
        name: '',
        email: '',
        phoneNo: '',
        shortDescription: '',
        enquiryType: '',
    };
    const [isRequestAlive, setIsRequestAlive] = useState(false);
    const [musicStudioFormSubmitted, setMusicStudioFormSubmitted] = useState(null);
    const {
        register: msFormRegister, handleSubmit: msFormHandleSubmit,
        formState: { errors: msFormErrors, isDirty: msFormIsDirty, isValid: msFormIsValid },
        watch: msFormWatch, reset: msFormReset, setValue: msFormSetValue,
    } = useForm({
        mode: 'all',
        defaultValues: { ...musicStudioFormDefaultValues }
    });

    const msFormLabel = {
        "1to1_tuition_adult": {
            name: { label: 'Name', placeholder: 'Enter name', reqMsg: 'Name field is required.' },
            email: { label: 'Email', placeholder: 'Enter email', reqMsg: 'Email field is required.' },
            phoneNo: { label: 'Phone Number', placeholder: 'Enter phone number', reqMsg: '' },
        },
        "1to1_tuition": {
            name: { label: 'Parent Name', placeholder: 'Enter parent name', reqMsg: '' },
            email: { label: 'Parent Email', placeholder: 'Enter parent email', reqMsg: '' },
            phoneNo: { label: 'Parent Phone Number', placeholder: 'Enter parent phone number', reqMsg: '' },
        },
        "book_the_studio": {
            name: { label: 'Name', placeholder: 'Enter name', reqMsg: '' },
            email: { label: 'Email', placeholder: 'Enter email', reqMsg: '' },
            phoneNo: { label: 'Phone Number', placeholder: 'Enter phone number', reqMsg: '' },
        }
    };

    const onMSFormSubmit = (data, e) => {
        e.preventDefault();
        try {
            if (!msFormIsValid || !msFormIsDirty || isRequestAlive) {
                return;
            }
            setIsRequestAlive(true);
            musicStudioEnquiryService.create(data).then((res) => {
                const defData = { ...musicStudioFormDefaultValues, enquiryType: data.enquiryType };
                if (data.enquiryType === '1to1_tuition') {
                    defData.studentName = '';
                    defData.wouldParentLikeToAttend = false;
                } else if (data.enquiryType === 'book_the_studio') {
                    defData.hasUsedStudioBefore = false;
                    defData.requiresEngineer = false;
                }
                msFormReset(defData);
                setMusicStudioFormSubmitted(setTimeout(() => {
                    setMusicStudioFormSubmitted(null);
                }, 8000));
                setIsRequestAlive(false);
            }).catch(err => {
                setIsRequestAlive(false);
                console.log('Error while submitting music studio enquiry', err.error);
            });
        } catch (error) {
            setIsRequestAlive(false);
            console.log(`Error while register user`, error);
        }
    }

    const onCloseMSFormSubmit = (e) => {
        e?.stopPropagation();
        if (musicStudioFormSubmitted) {
            clearTimeout(musicStudioFormSubmitted);
            setMusicStudioFormSubmitted(null);
        }

        setIsMusicStudioBooking(false);
        setMusicStudioBookingType('');
        msFormReset({ ...musicStudioFormDefaultValues });
    }

    const watchMSFormEnquiryType = msFormWatch('enquiryType');
    const watchWouldParentLikeToAttend = msFormWatch('wouldParentLikeToAttend');
    const watchHasUsedStudioBefore = msFormWatch('hasUsedStudioBefore');
    const watchRequiresEngineer = msFormWatch('requiresEngineer');



    return (
        <div className="booking-container">

            <div className='booking-hero-wrapper'>
                <picture>
                    {selectedBooking?.heroImage?.list?.map((sourceItem, i) => {
                        return <source key={i} media={sourceItem?.media} srcSet={sourceItem?.srcset} />
                    })}
                    <img className='booking-hero-img' srcSet={selectedBooking?.heroImage?.default} draggable="false" alt="Chris standing up holding his daughter Elva" />
                </picture>
            </div>

            <div className={'booking-selection-container' + (['music_studio', 'venue_hire'].includes(selectedBookingType) ? ' border-0' : '')}>
                <div className='booking-selection-wrapper'>
                    <h4 className='booking-selection-types-title'>
                        We have amazing facilities to offer at #Merky FC HQ including our new EA Sports Gaming Hub and state-of-the-art Music Studio. We have a new 3G astroturf pitch that can be booked  full size, half and a third, perfect for 11 v 11 and 7v7 games.
                    </h4>
                    <div className='booking-selection-types-wrapper'>
                        {_subMenuList.map((item, i) => {
                            return (
                                <div key={i} className={'booking-selection-type' + (selectedBookingType === item.id ? ' selected' : '')} onClick={() => { onChangeBookingCategory(item.id) }}>
                                    {item.label.replaceAll('_', ' ')}
                                </div>
                            )
                        })}
                    </div>
                </div>

                <div className='booking-title-desc-wrapper'>
                    <h1 className='booking-title'>{selectedBooking && selectedBooking.bookingTitle}</h1>
                    <h4 className='booking-description'>{selectedBooking && selectedBooking.description}
                        {['venue_hire'].includes(selectedBookingType) && <>
                            {" "} <span className='common-enquire-link' onClick={onVenueEnquire}>enquire now</span>
                        </>}
                    </h4>
                    {!['venue_hire', 'music_studio'].includes(selectedBookingType) &&
                        <div className='crown-still'>
                            <img src={crownStill} draggable="false" alt='' />
                        </div>
                    }
                </div>

                {selectedBookingType === 'pitch' && //  + (selectedBookingType === 'pitch' ? ' show' : '')
                    <div className={'booking-pitch-filter-container show'}>
                        <div className='booking-pitch-filter-wrapper'>
                            <h4 className='booking-pitch-filter-title'>filter pitch by:</h4>
                            {
                                pitchFilterList.map((pitchFilterItem, i) => {
                                    return (
                                        <div className='booking-pitch-filter-item-wrapper' key={i}>
                                            <input className='booking-pitch-filter-item' type='radio' name='pitchFilter' checked={selectedPitchType === pitchFilterItem.name} value={pitchFilterItem.name} onChange={() => { }} />
                                            <label htmlFor='halfPitch'>
                                                <h4 className='booking-pitch-filter-item-label' onClick={() => onPitchFilterChange(i)}>{pitchFilterItem.label}</h4>
                                            </label>
                                        </div>
                                    );
                                })
                            }
                        </div>

                        <div className='booking-pitch-filter-m-container'>
                            <div className='booking-pitch-filter-m-btn-wrapper'>
                                <button type='button' onClick={() => onTogglePitchFilter()} className='booking-pitch-filter-m-btn'>filter pitch</button>
                            </div>
                        </div>
                    </div>
                }
                {
                    (!gridLayoutSetting.isWithBasket && !['music_studio', 'venue_hire'].includes(selectedBookingType)) &&
                    <div className='booking-checkout-m-container'>
                        <div className={'booking-checkout-m-btn-wrapper' + (selectedBookingType !== 'pitch' ? ' adjust-padding' : '')}>
                            <button type='button' className='booking-checkout-m-btn' onClick={() => setIsBasketMViewShow(true)}>checkout</button>
                        </div>
                    </div>
                }
            </div>




            {/* booking and basket sections */}
            {/* 'booking-section-container' + (selectedBookingType === "venue_hire" ? ' adjust-padding' : '') */}
            <div className={`booking-section-container${['venue_hire', 'music_studio'].includes(selectedBookingType) ? ' adjust-padding' : ''}`}>
                { /* pitch and games room section */}
                {['pitch', 'games_room'].includes(selectedBookingType) &&
                    <>
                        <div className={'booking-section-wrapper' + (gridLayoutSetting.isWithBasket ? '' : ' m-view')}>

                            <div className='booking-slots-container'>
                                <div className='booking-slots-wrapper'>
                                    {/* Previous button */}
                                    <div className={'booking-slot-previous-btn' + (slotBoundary.isPreviousSlotBtnDisabled ? ' disabled' : '')} onClick={() => onPreviousGetSlot()}>
                                        <svg fill="none" viewBox="6 -1 32 32">
                                            <path d="M25.0542 19.825V21.085H24.1792L15.7792 15.905V14.155L24.2142 8.975H25.0542V10.235L17.2842 14.96V15.1L25.0542 19.825Z" fill="#B3B4B4"></path>
                                            <g clipPath="url(#clip0_1347_20751)">
                                                <path d="M31.1515 30.5H31.3586L31.505 30.3536L37.3536 24.505L37.5 24.3586V24.1515V5.84852V5.64142L37.3536 5.49497L31.505 -0.353553L31.3586 -0.5H31.1515H12.8485H12.6414L12.495 -0.353553L6.64645 5.49497L6.5 5.64142V5.84852V24.1515V24.3586L6.64645 24.505L12.495 30.3536L12.6414 30.5H12.8485H31.1515ZM35.5293 23.5452L30.5424 28.5321H13.4548L8.46792 23.5452V6.45756L13.4576 1.46792H30.5424L35.5293 6.45749V23.5452Z" fill="#B3B4B4" stroke="#B3B4B4"></path>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1347_20751">
                                                    <rect width="30" height="30" fill="white" transform="translate(7)"></rect>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>

                                    {/* date wise grid based on width, grid like small screen to large  1,  1 2,  1 2 3  */}
                                    <div className={'booking-slots' + (gridLayoutSetting.gridSize !== 3 ? ` size-${gridLayoutSetting.gridSize}` : '')}>
                                        {
                                            slotList?.map((slotItem, i) => {
                                                return (
                                                    <div className='booking-slot-wrapper' key={i}>
                                                        <div className='booking-slot-title'>{slotItem?.dDate}</div>
                                                        <div className='booking-slot-list'>
                                                            {slotItem?.slot?.map((slot, ii) => {
                                                                return (
                                                                    <div className={'booking-slot-details' + (slot?.isBooked ? ' booked' : '')} key={`${i},${ii}`}>
                                                                        <h4 className='booking-slot-detail-title'>{`${slot.startHs}:${slot.startMs}-${slot.endHs}:${slot.endMs}`}</h4>

                                                                        {slot?.isBooked ?
                                                                            <>{/* for booked state, just for display the information to the user  */}
                                                                                <div className='booking-slot-detail-input-wrapper'>
                                                                                    {selectedBookingType === 'pitch' ?
                                                                                        `${selectedPitchType.replace('_', ' ')} \u00A0|\u00A0 £${slot.price}`
                                                                                        :
                                                                                        <>
                                                                                            {`${selectedBookingType === 'music_studio' ? 'people' : 'console'} \u00A0`}
                                                                                            <input className='booking-slot-detail-input-field' type='number' defaultValue={'01'} readOnly />{`\u00A0 |\u00A0 £${slot.price}`}
                                                                                        </>
                                                                                    }
                                                                                </div>
                                                                                <div className='booking-slot-detail-add-link'>not available</div>
                                                                            </> :
                                                                            <>{/* for available state */}
                                                                                <div className='booking-slot-detail-input-wrapper'>
                                                                                    {selectedBookingType === 'pitch' ?
                                                                                        `${selectedPitchType.replace('_', ' ')} \u00A0|\u00A0 £${slot.price}`
                                                                                        :
                                                                                        selectedBookingType === 'music_studio' ?
                                                                                            <>
                                                                                                <span id={`people-label-${i}-${ii}`}>people &nbsp;</span><input className='booking-slot-detail-input-field' type='number' name={`slotLimit-${i}-${ii}`} defaultValue={'01'} min={1} max={slotConfig?.maxLimitPerSlot} onBlur={(e) => onMaxLimitPerSlotBlur(e)} />{`\u00A0 |\u00A0 £${slot.price}`}
                                                                                                {/* onChange={(e) => onChangeForInputPrefix(e, `people-label-${i}-${ii}`)}  */}
                                                                                            </>
                                                                                            :
                                                                                            <>
                                                                                                <span id={`console-label-${i}-${ii}`}>console &nbsp;</span><input className='booking-slot-detail-input-field' type='number' name={`slotLimit-${i}-${ii}`} defaultValue={'01'} min={1} max={slot?.availableConsoles || slotConfig?.maxLimitPerSlot} onBlur={(e) => onMaxLimitPerSlotBlur(e, slot?.availableConsoles)}
                                                                                                    onChange={(e) => onChangeForInputPrefix(e, `console-label-${i}-${ii}`)} />{`\u00A0 |\u00A0 £${slot.price}`}
                                                                                            </>
                                                                                    }
                                                                                </div>
                                                                                <div className='booking-slot-detail-add-link' onClick={() => onAddToBasket(i, ii)}>
                                                                                    add to basket
                                                                                </div>
                                                                                {/* {!isUserLoggedIn() && <>
                                                                                    <div className='sign-in-popup'>Please login for booking</div>
                                                                                    <div className='sign-in-popup-arrow'></div>
                                                                                </>} */}
                                                                            </>
                                                                        }
                                                                    </div>
                                                                );
                                                            })}
                                                            {!slotItem?.slot?.length &&
                                                                <div className='booking-slot-details booked'>
                                                                    <h4 className='booking-slot-detail-title'>not <br /> available!</h4>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>

                                    {/* next button */}
                                    <div className={'booking-slot-next-btn' + (slotBoundary.isNextSlotBtnDisabled ? ' disabled' : '')} onClick={() => onNextGetSlot()}>
                                        <svg fill="none" viewBox="4 -1 32 32">
                                            <path d="M15.7792 10.235V8.975H16.6542L25.0542 14.155V15.905L16.6192 21.085H15.7792V19.825L23.5492 15.1V14.96L15.7792 10.235Z" fill="#B3B4B4"></path>
                                            <g clipPath="url(#clip0_196_6744)">
                                                <path d="M29.1515 30.5H29.3586L29.505 30.3536L35.3536 24.505L35.5 24.3586V24.1515V5.84852V5.64142L35.3536 5.49497L29.505 -0.353553L29.3586 -0.5H29.1515H10.8485H10.6414L10.495 -0.353553L4.64645 5.49497L4.5 5.64142V5.84852V24.1515V24.3586L4.64645 24.505L10.495 30.3536L10.6414 30.5H10.8485H29.1515ZM33.5293 23.5452L28.5424 28.5321H11.4548L6.46792 23.5452V6.45756L11.4576 1.46792H28.5424L33.5293 6.45749V23.5452Z" fill="#B3B4B4" stroke="#B3B4B4"></path>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_196_6744">
                                                    <rect width="30" height="30" fill="white" transform="translate(5)"></rect>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                </div>
                            </div>


                            <div className={'booking-basket-container' + (isBasketMViewShow ? ' show' : '')}>
                                <div className='booking-basket-wrapper sticky'>
                                    <h4 className='booking-basket-title'>your basket</h4>
                                    {!gridLayoutSetting.isWithBasket && isBasketMViewShow &&
                                        <div className='booking-basket-close-btn-wrap' onClick={() => setIsBasketMViewShow(false)}>
                                            <svg width="20" height="20" viewBox="0 0 32 32" fill="none">
                                                <path d="M32 4.03186L27.9681 0L16.0116 11.9566L4.03186 0L0 4.03186L11.9566 16.0116L0 27.9681L4.03186 32L16.0116 20.0434L27.9681 32L32 27.9681L20.0434 16.0116L32 4.03186Z" fill="#B4B3B3" />
                                            </svg>
                                        </div>
                                    }

                                    <BookingBasket myBasket={myBasket} isCheckoutRequestAlive={isCheckoutRequestAlive}
                                        musicStudioSubAssetsConfig={musicStudioSubAssetsConfig} onRemoveToBasket={onRemoveToBasket} onCheckout={onCheckout}></BookingBasket>
                                    {/* <div className='booking-basket-items'>

                                        {myBasket.list?.map((basketItem, i) => {
                                            return <div className='booking-basket-item' key={i}>
                                                <div className='booking-basket-item-detail'>{`${basketItem?.previewDate} //`}</div>
                                                <div className='booking-basket-item-detail'>{`${basketItem?.startHs}:${basketItem?.startMs}-${basketItem?.endHs}:${basketItem?.endMs} //`}</div>
                                                <div className='booking-basket-item-detail'>{`${basketItem?.name} //`}</div>
                                                {basketItem.type === "MUSIC_STUDIO" && <div className='booking-basket-item-detail'>{`${basketItem?.peopleCount} People //`}</div>}
                                                {basketItem.type === "GAMES_ROOM" && <div className='booking-basket-item-detail'>{`£${basketItem?.price} X ${basketItem?.consoleCount}(Console${basketItem?.consoleCount > 1 ? 's' : ''}) //`}</div>}
                                                <div className='booking-basket-item-action-wrapper'>
                                                    {basketItem.type === "GAMES_ROOM" ?
                                                        <div className='booking-basket-item-price'>{`£${basketItem?.price * basketItem?.consoleCount}`}</div>
                                                        :
                                                        <div className='booking-basket-item-price'>{`£${basketItem?.price}`}</div>
                                                    }
                                                    <div className='booking-basket-item-remove' onClick={() => onRemoveToBasket(i)}>x remove</div>
                                                </div>
                                            </div>
                                        })}

                                        {!myBasket.list?.length &&
                                            <div className='booking-basket-item'>
                                                <div className='booking-basket-empty-box'>
                                                    <h4 className='booking-basket-empty-box-msg'>your basket is empty.</h4>
                                                </div>
                                            </div>
                                        }

                                    </div>

                                    {(myBasket?.list?.length > 0) && <>
                                        <div className='booking-basket-footer-wrapper'>
                                            <div className='booking-basket-totals'>
                                                <h4 className='booking-basket-total-title'>Total</h4>
                                                <h4 className='booking-basket-total-price'>{`£${myBasket?.total}`}</h4>
                                            </div>

                                            <div className='booking-basket-divider'></div>

                                            <div className='booking-basket-action-wrapper'>
                                                <button type='button' className={'booking-basket-action-btn' + (isCheckoutRequestAlive ? ' disabled' : '')} onClick={onCheckout} disabled={isCheckoutRequestAlive}>
                                                    <h4 className='booking-basket-action-btn-text'>checkout</h4>
                                                </button>
                                            </div>
                                        </div>
                                    </>} */}
                                </div>
                            </div>

                        </div>
                    </>
                }
                {/* music studio section */}
                {selectedBookingType === "music_studio" && <>{!isMusicStudioBooking ?
                    <>
                        {/* master class section */}
                        <MusicStudioSection pageContent={_MUSIC_STUDIO_CONTENT.mc}>
                            <button className='music-studio-action-button' onClick={(e) => onVenueEnquire(e, 'masterclass')}>
                                Book now
                            </button>
                            <button className='music-studio-action-button' onClick={onDownloadMusicStudioBrochure}>
                                Download Brochure
                            </button>
                        </MusicStudioSection>
                        {/* mini master class section */}
                        <MusicStudioSection pageContent={_MUSIC_STUDIO_CONTENT.mmc}>
                            <button className='music-studio-action-button' onClick={(e) => onVenueEnquire(e, 'mini_masterclass')}>
                                Book now
                            </button>
                            <button className='music-studio-action-button' onClick={onDownloadMusicStudioBrochure}>
                                Download Brochure
                            </button>
                        </MusicStudioSection>
                        {/* book the studio section */}
                        <MusicStudioSection pageContent={_MUSIC_STUDIO_CONTENT.bts}>
                            <button className='music-studio-action-button' onClick={(e) => onVenueEnquire(e, 'book_the_studio')}>
                                Book now
                            </button>
                        </MusicStudioSection>
                        {/* 1:1 tuition section */}
                        <MusicStudioSection pageContent={_MUSIC_STUDIO_CONTENT.t1to1}>
                            <button className='music-studio-action-button' onClick={(e) => onVenueEnquire(e, '1to1_tuition_adult')}>
                                Book now (18+)
                            </button>
                            <button className='music-studio-action-button' onClick={(e) => onVenueEnquire(e, '1to1_tuition')}>
                                Book now (under 18)
                            </button>
                        </MusicStudioSection>
                    </> :
                    <div className='music-studio-booking-section'>
                        {/* `master class` and `mini master class` section */}
                        {['masterclass', 'mini_masterclass'].includes(musicStudioBookingType) && <div className='music-studio-booking-wrapper'>
                            <div className='music-studio-booking'>
                                {/* onSubmit(data, e) */} {/* musicStudioBookingType: {musicStudioBookingType} */}
                                <form className='ms-booking-form' onSubmit={handleSubmit(onAddToBasketMusicStudio)} autoComplete="off">
                                    <div className='input-field-wrap'>
                                        <div className='input-field-group'>
                                            <select className={`input-field select-input${watchAsset ? '' : ' placeholder'}`} name='asset'
                                                {...register('asset', {
                                                    required: 'Please select class.',
                                                })} defaultValue=''>

                                                <option value='' disabled>Select Class</option>
                                                {musicStudioAssetList.map((asset, i) => <option key={i} value={asset.id}>{asset.label}</option>)}
                                            </select>
                                            {(touchedFields.asset && errors.asset) && (<h4 className='input-field-err-msg'>
                                                {errors.asset.message}
                                            </h4>)}
                                        </div>
                                    </div>

                                    <div className='input-field-wrap'>
                                        <div className='input-field-group'>
                                            <select className={`input-field select-input${watchSubAsset ? '' : ' placeholder'}`} name='subAsset'
                                                {...register('subAsset', {
                                                    required: 'Please select sub class.',
                                                })} defaultValue=''>

                                                <option value='' disabled>Select Sub Class</option>
                                                {filteredMusicStudioSubAssetList.map((asset, i) =>
                                                    <option key={i} value={asset?._id}>{asset.name} (£{asset.price})</option>
                                                )}
                                            </select>
                                            {(touchedFields.subAsset && errors.subAsset) && (<h4 className='input-field-err-msg'>
                                                {errors.subAsset.message}
                                            </h4>)}
                                        </div>
                                    </div>

                                    {watchSubAsset && <div className='input-field-wrap'>
                                        <table className='time-slot-table'>
                                            <thead>
                                                <tr>
                                                    <th className='time-slot-table-header'>Dates of class</th>
                                                    <th className='time-slot-table-header'>Start to End time</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {musicStudioSlotList.map((item, i) => {
                                                    return item?.slots?.map((slot, ii) => {
                                                        return (
                                                            <tr key={`${i}-${ii}`} className='time-slot-row'>
                                                                {ii === 0 && (
                                                                    <td rowSpan={item.slots.length} className='time-slot-table-data class-date'>
                                                                        {item?.dDate}
                                                                    </td>
                                                                )}
                                                                <td className='time-slot-table-data'>
                                                                    {`${slot.startHours}:${slot.startMinutes} to ${slot.endHours}:${slot.endMinutes}`}
                                                                </td>
                                                            </tr>
                                                        );
                                                    });
                                                })}
                                                {musicStudioSlotList.length === 0 && (<tr className='time-slot-row'>
                                                    <td className='no-slots-available'>
                                                        -
                                                    </td>
                                                    <td className='no-slots-available'>
                                                        No slots available.
                                                    </td>
                                                </tr>)}
                                            </tbody>
                                        </table>
                                    </div>}

                                    <div className='input-field-wrap'>
                                        <div className='input-field-group'>
                                            <input type='number' name='numberOfSeats' className='input-field' placeholder='number of seats'
                                                min={musicStudioSubAssetsConfig[watchSubAsset]?.availableSeats ? 1 : 0}
                                                max={musicStudioSubAssetsConfig[watchSubAsset]?.availableSeats ?? 1}
                                                {...register('numberOfSeats', {
                                                    required: 'This field is required.',
                                                    // validate the min and max value based on the selected time slot
                                                    validate: (value) => {
                                                        const maxLimit = musicStudioSubAssetsConfig[watchSubAsset]?.availableSeats;
                                                        if (maxLimit === 0) {
                                                            return 'No seats available.';
                                                        } else if (maxLimit && value > maxLimit) {
                                                            return `Maximum ${maxLimit} seats available.`;
                                                        } else if (value < 1) {
                                                            return 'Minimum 1 seat required.';
                                                        }
                                                        return true;
                                                    }
                                                })} />
                                            {errors.numberOfSeats && (<h4 className='input-field-err-msg'>
                                                {errors.numberOfSeats.message}
                                            </h4>)}
                                        </div>
                                    </div>

                                    <div className='action-wrapper'>
                                        <div className='button-group'>
                                            <button className={'action-btn'} type='button' onClick={(e) => onGoBackMusicStudio(e)}>
                                                <span className='btn-label'>Go Back</span>
                                            </button>
                                            {/* class: 'in-valid' */}
                                            <button className={'action-btn'} type='submit' disabled={false}>
                                                <span className='btn-label'>add to basket</span>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className='booking-basket-section'>
                                <div className='booking-basket-wrapper'>
                                    <h4 className='booking-basket-title'>your basket</h4>
                                    <BookingBasket musicStudioSubAssetsConfig={musicStudioSubAssetsConfig}
                                        myBasket={myBasket} isCheckoutRequestAlive={isCheckoutRequestAlive}
                                        onRemoveToBasket={onRemoveToBasket} onCheckout={onCheckout}>
                                    </BookingBasket>
                                </div>
                            </div>
                        </div>}

                        {['book_the_studio', '1to1_tuition', '1to1_tuition_adult'].includes(musicStudioBookingType) && <div className='music-studio-booking-wrapper'>
                            <div className='music-studio-booking'>
                                <form className='music-studio-form-wrap' onSubmit={msFormHandleSubmit(onMSFormSubmit)} autoComplete="off">
                                    {watchMSFormEnquiryType === '1to1_tuition' &&
                                        <div>
                                            <div className='music-studio-form-item'>
                                                <input className='music-studio-form-item-input' type='text' name='studentName' placeholder='Enter student name'
                                                    {...msFormRegister('studentName', {
                                                        required: 'Field is required.',
                                                        validate: value => value.trim() !== '' || 'Field cannot be empty.'
                                                    })} />
                                            </div>
                                            {(msFormErrors.studentName) && (<h4 className='music-studio-form-item-err-msg'>
                                                {msFormErrors.studentName.message}
                                            </h4>)}
                                        </div>
                                    }
                                    <div>
                                        <div className='music-studio-form-item'>
                                            <input className='music-studio-form-item-input' type='text' name='name' placeholder={msFormLabel[musicStudioBookingType]?.name?.placeholder}
                                                {...msFormRegister('name', {
                                                    required: 'Field is required.',
                                                    validate: value => value.trim() !== '' || 'Field cannot be empty.'
                                                })} />
                                        </div>
                                        {(msFormErrors.name) && (<h4 className='music-studio-form-item-err-msg'>
                                            {msFormErrors.name.message}
                                        </h4>)}
                                    </div>
                                    <div>
                                        <div className='music-studio-form-item'>
                                            <input className='music-studio-form-item-input' type='text' name='phoneNo' placeholder={msFormLabel[musicStudioBookingType]?.phoneNo?.placeholder}
                                                {...msFormRegister('phoneNo', {
                                                    required: 'Field is required.',
                                                    pattern: {
                                                        value: Regexp._MOBILE_NUMBER,
                                                        message: 'Please enter valid phone number.'
                                                    },
                                                    validate: value => value.trim() !== '' || 'Field cannot be empty.'
                                                })} />
                                        </div>
                                        {msFormErrors.phoneNo && (<h4 className='music-studio-form-item-err-msg'>
                                            {msFormErrors.phoneNo.message}
                                        </h4>)}
                                    </div>
                                    <div>
                                        <div className='music-studio-form-item'>
                                            <input className='music-studio-form-item-input' type='text' name='email' placeholder={msFormLabel[musicStudioBookingType]?.email?.placeholder}
                                                {...msFormRegister('email', {
                                                    required: 'Filed is required.',
                                                    pattern: {
                                                        value: Regexp._EMAIL,
                                                        message: 'Please enter valid e-mail address.'
                                                    },
                                                    validate: (value) => (value?.length > 254 ? 'An email address must not exceed 254 characters.' : null)
                                                })} />
                                        </div>
                                        {(msFormErrors.email) && (<h4 className='music-studio-form-item-err-msg'>
                                            {msFormErrors.email.message}
                                        </h4>)}
                                    </div>

                                    {/* add field for `1to1_tuition` */}
                                    {watchMSFormEnquiryType === '1to1_tuition' && <>
                                        <div className='ms-checkbox-container'>
                                            <div className='ms-checkbox-wrapper'>
                                                <label htmlFor='wouldParentLikeToAttend'>
                                                    <CheckboxIcon
                                                        key={'wouldParentLikeToAttend'}
                                                        isChecked={watchWouldParentLikeToAttend}
                                                        classNames={'ms-checkbox-icon'}
                                                    ></CheckboxIcon>
                                                </label>
                                                <input className='ms-checkbox-input' type='checkbox' {...msFormRegister('wouldParentLikeToAttend')}
                                                    name='wouldParentLikeToAttend' id='wouldParentLikeToAttend' />
                                            </div>
                                            <span className='ms-checkbox-label'>
                                                would parent like to attend?
                                            </span>
                                        </div>
                                    </>}
                                    {/* add field for `book_the_studio` */}
                                    {watchMSFormEnquiryType === 'book_the_studio' && <>
                                        <div className='ms-checkbox-container'>
                                            <div className='ms-checkbox-wrapper'>
                                                <label htmlFor='hasUsedStudioBefore'>
                                                    <CheckboxIcon
                                                        key={'hasUsedStudioBefore'}
                                                        isChecked={watchHasUsedStudioBefore}
                                                        classNames='ms-checkbox-icon'
                                                    ></CheckboxIcon>
                                                </label>
                                                <input className='ms-checkbox-input' type='checkbox' {...msFormRegister('hasUsedStudioBefore')}
                                                    name='hasUsedStudioBefore' id='hasUsedStudioBefore' />
                                            </div>
                                            <span className='ms-checkbox-label'>
                                                Have you used the studio before?
                                            </span>
                                        </div>

                                        <div className='ms-checkbox-container'>
                                            <div className='ms-checkbox-wrapper'>
                                                <label htmlFor='requiresEngineer'>
                                                    <CheckboxIcon
                                                        key={'requiresEngineer'}
                                                        isChecked={watchRequiresEngineer}
                                                        classNames='ms-checkbox-icon'
                                                    ></CheckboxIcon>
                                                </label>
                                                <input className='ms-checkbox-input' type='checkbox' {...msFormRegister('requiresEngineer')}
                                                    name='requiresEngineer' id='requiresEngineer' />
                                            </div>
                                            <span className='ms-checkbox-label'>
                                                Do you require an engineer?
                                            </span>
                                        </div>
                                    </>}

                                    <div>
                                        <div className='music-studio-form-item multiline'>
                                            <textarea className='music-studio-form-item-input' name='shortDescription'
                                                placeholder='please give a short description of what you would like to use the studio for'
                                                {...msFormRegister('shortDescription', {
                                                    required: 'Field is required.',
                                                    validate: value => value.trim() !== '' || 'Field cannot be empty.'
                                                })} ></textarea>
                                        </div>
                                        {(msFormErrors.shortDescription) && (<h4 className='music-studio-form-item-err-msg'>
                                            {msFormErrors.shortDescription.message}
                                        </h4>)}
                                    </div>

                                    <div className='music-studio-form-action-wrapper'>
                                        <button className='music-studio-form-action-btn' type='button' onClick={onCloseMSFormSubmit} disabled={isRequestAlive}>
                                            go back
                                        </button>
                                        <button className='music-studio-form-action-btn' type='submit' disabled={isRequestAlive}>
                                            submit enquiry
                                        </button>
                                    </div>
                                </form>

                                {musicStudioFormSubmitted &&
                                    <div className='music-studio-form-submitted-ctr'>
                                        <div className='music-studio-form-submitted-wrapper'>
                                            <div className='music-studio-form-submitted-modal-close-btn' onClick={onCloseMSFormSubmit}>
                                                <svg viewBox="0 0 32 32" fill="none">
                                                    <path d="M32 4.03186L27.9681 0L16.0116 11.9566L4.03186 0L0 4.03186L11.9566 16.0116L0 27.9681L4.03186 32L16.0116 20.0434L27.9681 32L32 27.9681L20.0434 16.0116L32 4.03186Z" fill="#1E1E1E" />
                                                </svg>
                                            </div>

                                            <div className='music-studio-form-submitted-poster-wrapper'>
                                                <img className='music-studio-form-submitted-poster' draggable="false" alt='left poster' />
                                            </div>
                                            <div className='music-studio-form-submitted-section-wrapper'>
                                                <div className='music-studio-form-submitted-section'>
                                                    <div>
                                                        <h4 className='music-studio-form-submitted-section-title'>request submitted</h4>
                                                        <p className='music-studio-form-submitted-section-description mb'>
                                                            Thanks for requesting to book music studio/tuition . We’ll be in touch soon.
                                                        </p>
                                                    </div>

                                                    <div className='music-studio-form-submitted-section-action'>
                                                        <button className='music-studio-form-submitted-section-submit-btn' type='button' onClick={onCloseMSFormSubmit}>
                                                            close
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>}
                    </div>
                }</>}
                {/* venue hire section */}
                {selectedBookingType === "venue_hire" &&
                    <>
                        <VenueHireRoom key={'copaMundial'} loadFor={'copaMundial'} onVenueEnquire={onVenueEnquire} onDownloadBrochure={onDownloadBrochure} />

                        <VenueHireRoom key={'viewPoint'} loadFor={'viewPoint'} onVenueEnquire={onVenueEnquire} onDownloadBrochure={onDownloadBrochure} />

                        <VenueHireRoom key={'worldCupRoom'} loadFor={'worldCupRoom'} onVenueEnquire={onVenueEnquire} onDownloadBrochure={onDownloadBrochure} />

                        <div className='venue-address-map-container'>
                            <div className='venue-address-text-wrap'>
                                <p className='venue-address-text'>* PLEASE NOTE: 1st floor capacity can not exceed 100 people.</p>
                            </div>
                            <div className='venue-address-map-wrap'>
                                <h3 className='venue-map-title'>venue map</h3>
                                <div className='venue-address-map'>
                                    <svg width="658" height="373" viewBox="0 0 658 373" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" className='venue-address-map-icon'>
                                        <rect x="1" y="1" width="655.958" height="371" fill="url(#pattern0_87_204)" />
                                        <rect x="1" y="1" width="655.958" height="371" fill="black" />
                                        <rect x="1" y="1" width="655.958" height="371" stroke="#4F5050" strokeWidth="2" />
                                        <rect x="172.16" y="23.2046" width="462.593" height="324.741" fill="url(#pattern1_87_204)" />
                                        <rect x="172.16" y="23.2046" width="462.593" height="324.741" fill="#2A2A2A" />
                                        <rect x="23.2046" y="230.447" width="243.324" height="117.499" fill="url(#pattern2_87_204)" />
                                        <rect x="23.2046" y="230.447" width="243.324" height="117.499" fill="#2A2A2A" />
                                        <rect x="172.413" y="59.0374" width="141.719" height="288.837" fill="#5B5B5B" className='room-rect' />
                                        <path className='room-rect-text' d="M230.15 203.073C231.662 203.073 232.814 203.775 233.21 206.403L231.968 206.691C231.698 204.765 231.104 204.243 230.24 204.243C228.818 204.243 228.152 205.971 228.152 209.409C228.152 212.325 228.674 214.341 230.204 214.341C231.158 214.341 231.68 213.729 231.968 212.001L233.21 212.217C232.706 214.827 231.644 215.511 230.168 215.511C227.72 215.511 226.712 213.153 226.712 209.517C226.712 206.007 227.702 203.073 230.15 203.073ZM239.423 203.073C241.745 203.073 242.987 205.053 242.987 209.211C242.987 210.813 242.789 212.379 242.195 213.657C241.601 214.935 240.719 215.511 239.423 215.511C237.065 215.511 235.877 213.603 235.877 209.373C235.877 205.287 237.101 203.073 239.423 203.073ZM237.299 209.103C237.299 212.649 237.911 214.341 239.423 214.341C240.863 214.341 241.547 212.847 241.547 209.301C241.547 205.755 240.899 204.243 239.405 204.243C238.019 204.243 237.299 205.737 237.299 209.103ZM246.669 203.289H248.991C249.909 203.289 250.593 203.415 251.043 203.667C251.925 204.171 252.519 205.251 252.519 206.889C252.519 209.139 251.313 210.417 249.279 210.417H248.037V215.295H246.669V203.289ZM248.037 209.247H249.225C250.593 209.247 251.133 208.491 251.133 206.889C251.133 205.359 250.539 204.459 249.261 204.459H248.037V209.247ZM256.503 203.289H257.925L260.625 215.295H259.221L258.465 211.821H255.783L255.045 215.295H253.749L256.503 203.289ZM257.151 204.729L256.017 210.705H258.249L257.151 204.729ZM212.657 222.289H214.475L216.869 232.045L219.299 222.289H221.081V234.295H219.749L219.857 224.053L217.319 234.295H216.293L213.773 223.999L213.881 234.295H212.657V222.289ZM224.964 222.289H226.332V230.857C226.332 232.657 226.692 233.341 227.988 233.341C229.302 233.341 229.752 232.603 229.752 230.821V222.289H231.066V230.857C231.066 233.557 229.95 234.511 227.97 234.511C225.702 234.511 224.964 233.431 224.964 231.037V222.289ZM234.96 222.289H236.598L240.396 231.685L240.324 222.289H241.548V234.295H240.216L236.112 224.017L236.184 234.295H234.96V222.289ZM245.655 222.289H247.743C248.931 222.289 249.831 222.523 250.461 222.991C251.721 223.927 252.351 226.033 252.351 228.193C252.351 229.759 252.009 231.217 251.361 232.423C250.695 233.665 249.651 234.295 247.887 234.295H245.655V222.289ZM247.023 223.459V233.125H248.103C248.949 233.125 249.741 232.693 250.173 231.901C250.695 230.947 250.929 229.399 250.911 228.265C250.857 224.665 249.813 223.459 247.797 223.459H247.023ZM256.033 222.289H257.401V234.295H256.033V222.289ZM263.037 222.289H264.459L267.159 234.295H265.755L264.999 230.821H262.317L261.579 234.295H260.283L263.037 222.289ZM263.685 223.729L262.551 229.705H264.783L263.685 223.729ZM270.057 222.289H271.425V233.125H275.169V234.295H270.057V222.289Z" fill="#B3B4B4" />
                                        <rect x="22.5953" y="230.45" width="149.817" height="117.425" fill="#5B5B5B" className='room-rect' />
                                        <path className='room-rect-text' d="M68.4916 277.903C70.8136 277.903 72.0556 279.883 72.0556 284.041C72.0556 285.643 71.8576 287.209 71.2636 288.487C70.6696 289.765 69.7876 290.341 68.4916 290.341C66.1336 290.341 64.9456 288.433 64.9456 284.203C64.9456 280.117 66.1696 277.903 68.4916 277.903ZM66.3676 283.933C66.3676 287.479 66.9796 289.171 68.4916 289.171C69.9316 289.171 70.6156 287.677 70.6156 284.131C70.6156 280.585 69.9676 279.073 68.4736 279.073C67.0876 279.073 66.3676 280.567 66.3676 283.933ZM75.5217 278.119H76.8897V286.687C76.8897 288.487 77.2497 289.171 78.5457 289.171C79.8597 289.171 80.3097 288.433 80.3097 286.651V278.119H81.6237V286.687C81.6237 289.387 80.5077 290.341 78.5277 290.341C76.2597 290.341 75.5217 289.261 75.5217 286.867V278.119ZM84.2761 278.119H90.2882V279.289H87.9661V290.125H86.5981V279.289H84.2761V278.119ZM93.1541 278.119H95.2421C96.4301 278.119 97.3301 278.353 97.9601 278.821C99.2201 279.757 99.8501 281.863 99.8501 284.023C99.8501 285.589 99.5081 287.047 98.8601 288.253C98.1941 289.495 97.1501 290.125 95.3861 290.125H93.1541V278.119ZM94.5221 279.289V288.955H95.6021C96.4481 288.955 97.2401 288.523 97.6721 287.731C98.1941 286.777 98.4281 285.229 98.4101 284.095C98.3561 280.495 97.3121 279.289 95.2961 279.289H94.5221ZM106.664 277.903C108.986 277.903 110.228 279.883 110.228 284.041C110.228 285.643 110.03 287.209 109.436 288.487C108.842 289.765 107.96 290.341 106.664 290.341C104.306 290.341 103.118 288.433 103.118 284.203C103.118 280.117 104.342 277.903 106.664 277.903ZM104.54 283.933C104.54 287.479 105.152 289.171 106.664 289.171C108.104 289.171 108.788 287.677 108.788 284.131C108.788 280.585 108.14 279.073 106.646 279.073C105.26 279.073 104.54 280.567 104.54 283.933ZM117.042 277.903C119.364 277.903 120.606 279.883 120.606 284.041C120.606 285.643 120.408 287.209 119.814 288.487C119.22 289.765 118.338 290.341 117.042 290.341C114.684 290.341 113.496 288.433 113.496 284.203C113.496 280.117 114.72 277.903 117.042 277.903ZM114.918 283.933C114.918 287.479 115.53 289.171 117.042 289.171C118.482 289.171 119.166 287.677 119.166 284.131C119.166 280.585 118.518 279.073 117.024 279.073C115.638 279.073 114.918 280.567 114.918 283.933ZM124.288 278.119H127.096C128.032 278.119 128.518 278.263 128.896 278.479C129.688 278.947 130.318 279.991 130.318 281.395C130.318 282.997 129.796 284.203 128.662 284.599L130.588 290.125H129.13L127.366 284.869H125.656V290.125H124.288V278.119ZM125.656 283.699H127.132C128.41 283.699 128.932 282.709 128.932 281.467C128.932 281.125 128.86 280.297 128.356 279.757C128.086 279.469 127.708 279.289 127.006 279.289H125.656V283.699ZM67.6244 297.119H73.6364V298.289H71.3144V309.125H69.9464V298.289H67.6244V297.119ZM76.5023 297.119H81.9923V298.289H77.8703V302.303H81.0563V303.473H77.8703V307.955H82.1003V309.125H76.5023V297.119ZM85.0523 297.119H87.8603C88.7963 297.119 89.2823 297.263 89.6603 297.479C90.4523 297.947 91.0823 298.991 91.0823 300.395C91.0823 301.997 90.5603 303.203 89.4263 303.599L91.3523 309.125H89.8943L88.1303 303.869H86.4203V309.125H85.0523V297.119ZM86.4203 302.699H87.8963C89.1743 302.699 89.6963 301.709 89.6963 300.467C89.6963 300.125 89.6243 299.297 89.1203 298.757C88.8503 298.469 88.4723 298.289 87.7703 298.289H86.4203V302.699ZM94.5164 297.119H97.3244C98.2604 297.119 98.7464 297.263 99.1244 297.479C99.9164 297.947 100.546 298.991 100.546 300.395C100.546 301.997 100.024 303.203 98.8904 303.599L100.816 309.125H99.3584L97.5944 303.869H95.8844V309.125H94.5164V297.119ZM95.8844 302.699H97.3604C98.6384 302.699 99.1604 301.709 99.1604 300.467C99.1604 300.125 99.0884 299.297 98.5844 298.757C98.3144 298.469 97.9364 298.289 97.2344 298.289H95.8844V302.699ZM105.51 297.119H106.932L109.632 309.125H108.228L107.472 305.651H104.79L104.052 309.125H102.756L105.51 297.119ZM106.158 298.559L105.024 304.535H107.256L106.158 298.559ZM115.554 296.903C117.066 296.903 118.218 297.605 118.614 300.233L117.372 300.521C117.102 298.595 116.508 298.073 115.644 298.073C114.222 298.073 113.556 299.801 113.556 303.239C113.556 306.155 114.078 308.171 115.608 308.171C116.562 308.171 117.084 307.559 117.372 305.831L118.614 306.047C118.11 308.657 117.048 309.341 115.572 309.341C113.124 309.341 112.116 306.983 112.116 303.347C112.116 299.837 113.106 296.903 115.554 296.903ZM121.696 297.119H127.186V298.289H123.064V302.303H126.25V303.473H123.064V307.955H127.294V309.125H121.696V297.119Z" fill="#B3B4B4" />
                                        <rect x="485.545" y="137.32" width="149.817" height="210.554" fill="#5B5B5B" className='room-rect' />
                                        <path className='room-rect-text' d="M519.559 237.456H520.927L522.439 246.942L524.149 237.456H525.283L527.155 246.942L528.559 237.456H529.783L527.785 249.462H526.435L524.689 240.228L522.979 249.462H521.683L519.559 237.456ZM535.959 237.24C538.281 237.24 539.523 239.22 539.523 243.378C539.523 244.98 539.325 246.546 538.731 247.824C538.137 249.102 537.255 249.678 535.959 249.678C533.601 249.678 532.413 247.77 532.413 243.54C532.413 239.454 533.637 237.24 535.959 237.24ZM533.835 243.27C533.835 246.816 534.447 248.508 535.959 248.508C537.399 248.508 538.083 247.014 538.083 243.468C538.083 239.922 537.435 238.41 535.941 238.41C534.555 238.41 533.835 239.904 533.835 243.27ZM543.205 237.456H546.013C546.949 237.456 547.435 237.6 547.813 237.816C548.605 238.284 549.235 239.328 549.235 240.732C549.235 242.334 548.713 243.54 547.579 243.936L549.505 249.462H548.047L546.283 244.206H544.573V249.462H543.205V237.456ZM544.573 243.036H546.049C547.327 243.036 547.849 242.046 547.849 240.804C547.849 240.462 547.777 239.634 547.273 239.094C547.003 238.806 546.625 238.626 545.923 238.626H544.573V243.036ZM552.669 237.456H554.037V248.292H557.781V249.462H552.669V237.456ZM560.604 237.456H562.692C563.88 237.456 564.78 237.69 565.41 238.158C566.67 239.094 567.3 241.2 567.3 243.36C567.3 244.926 566.958 246.384 566.31 247.59C565.644 248.832 564.6 249.462 562.836 249.462H560.604V237.456ZM561.972 238.626V248.292H563.052C563.898 248.292 564.69 247.86 565.122 247.068C565.644 246.114 565.878 244.566 565.86 243.432C565.806 239.832 564.762 238.626 562.746 238.626H561.972ZM579.638 237.24C581.15 237.24 582.302 237.942 582.698 240.57L581.456 240.858C581.186 238.932 580.592 238.41 579.728 238.41C578.306 238.41 577.64 240.138 577.64 243.576C577.64 246.492 578.162 248.508 579.692 248.508C580.646 248.508 581.168 247.896 581.456 246.168L582.698 246.384C582.194 248.994 581.132 249.678 579.656 249.678C577.208 249.678 576.2 247.32 576.2 243.684C576.2 240.174 577.19 237.24 579.638 237.24ZM585.563 237.456H586.931V246.024C586.931 247.824 587.291 248.508 588.587 248.508C589.901 248.508 590.351 247.77 590.351 245.988V237.456H591.665V246.024C591.665 248.724 590.549 249.678 588.569 249.678C586.301 249.678 585.563 248.598 585.563 246.204V237.456ZM595.559 237.456H597.881C598.799 237.456 599.483 237.582 599.933 237.834C600.815 238.338 601.409 239.418 601.409 241.056C601.409 243.306 600.203 244.584 598.169 244.584H596.927V249.462H595.559V237.456ZM596.927 243.414H598.115C599.483 243.414 600.023 242.658 600.023 241.056C600.023 239.526 599.429 238.626 598.151 238.626H596.927V243.414ZM541.134 256.456H543.942C544.878 256.456 545.364 256.6 545.742 256.816C546.534 257.284 547.164 258.328 547.164 259.732C547.164 261.334 546.642 262.54 545.508 262.936L547.434 268.462H545.976L544.212 263.206H542.502V268.462H541.134V256.456ZM542.502 262.036H543.978C545.256 262.036 545.778 261.046 545.778 259.804C545.778 259.462 545.706 258.634 545.202 258.094C544.932 257.806 544.554 257.626 543.852 257.626H542.502V262.036ZM553.73 256.24C556.052 256.24 557.294 258.22 557.294 262.378C557.294 263.98 557.096 265.546 556.502 266.824C555.908 268.102 555.026 268.678 553.73 268.678C551.372 268.678 550.184 266.77 550.184 262.54C550.184 258.454 551.408 256.24 553.73 256.24ZM551.606 262.27C551.606 265.816 552.218 267.508 553.73 267.508C555.17 267.508 555.854 266.014 555.854 262.468C555.854 258.922 555.206 257.41 553.712 257.41C552.326 257.41 551.606 258.904 551.606 262.27ZM564.108 256.24C566.43 256.24 567.672 258.22 567.672 262.378C567.672 263.98 567.474 265.546 566.88 266.824C566.286 268.102 565.404 268.678 564.108 268.678C561.75 268.678 560.562 266.77 560.562 262.54C560.562 258.454 561.786 256.24 564.108 256.24ZM561.984 262.27C561.984 265.816 562.596 267.508 564.108 267.508C565.548 267.508 566.232 266.014 566.232 262.468C566.232 258.922 565.584 257.41 564.09 257.41C562.704 257.41 561.984 258.904 561.984 262.27ZM571.354 256.456H573.172L575.566 266.212L577.996 256.456H579.778V268.462H578.446L578.554 258.22L576.016 268.462H574.99L572.47 258.166L572.578 268.462H571.354V256.456Z" fill="#B3B4B4" />
                                        <rect x="314.132" y="284.438" width="106.627" height="63.4362" fill="#5B5B5B" className='room-rect' />
                                        <path className='room-rect-text' d="M350.857 302.199H352.315L354.367 312.387L356.401 302.199H357.787L355.069 314.205H353.593L350.857 302.199ZM360.649 302.199H362.017V314.205H360.649V302.199ZM366.122 302.199H371.612V303.369H367.49V307.383H370.676V308.553H367.49V313.035H371.72V314.205H366.122V302.199ZM373.628 302.199H374.996L376.508 311.685L378.218 302.199H379.352L381.224 311.685L382.628 302.199H383.852L381.854 314.205H380.504L378.758 304.971L377.048 314.205H375.752L373.628 302.199ZM347.982 321.199H350.304C351.222 321.199 351.906 321.325 352.356 321.577C353.238 322.081 353.832 323.161 353.832 324.799C353.832 327.049 352.626 328.327 350.592 328.327H349.35V333.205H347.982V321.199ZM349.35 327.157H350.538C351.906 327.157 352.446 326.401 352.446 324.799C352.446 323.269 351.852 322.369 350.574 322.369H349.35V327.157ZM359.963 320.983C362.285 320.983 363.527 322.963 363.527 327.121C363.527 328.723 363.329 330.289 362.735 331.567C362.141 332.845 361.259 333.421 359.963 333.421C357.605 333.421 356.417 331.513 356.417 327.283C356.417 323.197 357.641 320.983 359.963 320.983ZM357.839 327.013C357.839 330.559 358.451 332.251 359.963 332.251C361.403 332.251 362.087 330.757 362.087 327.211C362.087 323.665 361.439 322.153 359.945 322.153C358.559 322.153 357.839 323.647 357.839 327.013ZM367.209 321.199H368.577V333.205H367.209V321.199ZM372.683 321.199H374.321L378.119 330.595L378.047 321.199H379.271V333.205H377.939L373.835 322.927L373.907 333.205H372.683V321.199ZM382.135 321.199H388.147V322.369H385.825V333.205H384.457V322.369H382.135V321.199Z" fill="#B3B4B4" />
                                        <path d="M509.993 144L509.993 148C509.993 162.359 498.353 174 483.993 174L483.993 144L509.993 144Z" fill="#2A2A2A" />
                                        <rect x="483.993" y="144" width="26" height="2" fill="#B3B4B4" />
                                        <path d="M484.493 174C493.16 173.833 510.393 168 509.993 146" stroke="#B3B4B4" strokeWidth="0.5" strokeDasharray="3 3" />
                                        <path d="M177 35.0068H181C195.359 35.0068 207 46.6474 207 61.0068H177V35.0068Z" fill="#2A2A2A" />
                                        <rect x="177" y="61.0068" width="26" height="2" transform="rotate(-90 177 61.0068)" fill="#B3B4B4" />
                                        <path d="M207 60.5068C206.833 51.8402 201 34.6068 179 35.0068" stroke="#B3B4B4" strokeWidth="0.5" strokeDasharray="3 3" />
                                        <path d="M148.007 323L148.007 319C148.007 304.64 159.647 293 174.007 293L174.007 323L148.007 323Z" fill="#2A2A2A" />
                                        <rect x="174.007" y="323" width="26" height="2" transform="rotate(180 174.007 323)" fill="#B3B4B4" />
                                        <rect x="315" y="298" width="26" height="2" transform="rotate(90 315 298)" fill="#B3B4B4" />
                                        <path d="M173.507 293C164.84 293.166 147.607 299 148.007 321" stroke="#B3B4B4" strokeWidth="0.5" strokeDasharray="3 3" />
                                        <path d="M414 308L410 308C395.641 308 384 296.359 384 282L414 282L414 308Z" fill="#2A2A2A" />
                                        <rect x="414" y="282" width="26" height="2" transform="rotate(90 414 282)" fill="#B3B4B4" />
                                        <path d="M384 282.5C384.167 291.167 390 308.4 412 308" stroke="#B3B4B4" strokeWidth="0.5" strokeDasharray="3 3" />
                                        <path d="M148.007 261L148.007 265C148.007 279.359 159.647 291 174.007 291L174.007 261L148.007 261Z" fill="#2A2A2A" />
                                        <rect width="26" height="2" transform="matrix(-1 -8.74228e-08 -8.74228e-08 1 174.007 261)" fill="#B3B4B4" />
                                        <path d="M173.507 291C164.84 290.833 147.607 285 148.007 263" stroke="#B3B4B4" strokeWidth="0.5" strokeDasharray="3 3" />
                                        <defs>
                                            <pattern id="pattern0_87_204" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                <use xlinkHref="#image0_87_204" transform="matrix(0.000568416 0 0 0.00047368 -0.00491383 -0.0115741)" />
                                            </pattern>
                                            <pattern id="pattern1_87_204" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                <use xlinkHref="#image0_87_204" transform="matrix(0.000568416 0 0 0.00047368 -0.00491383 -0.0115741)" />
                                            </pattern>
                                            <pattern id="pattern2_87_204" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                <use xlinkHref="#image0_87_204" transform="matrix(0.000568416 0 0 0.00047368 -0.00491383 -0.0115741)" />
                                            </pattern>
                                            <image id="image0_87_204" width="1801" height="2160" xlinkHref={_venueHireMapBg} />
                                        </defs>
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <button className='venue-enquire-footer-button' onClick={onVenueEnquire}>VENUE ENQUIRY FORM</button>
                    </>
                }
            </div>




            {/* booking pitch filter onscreen(as modal screen) for small screen based on togglePitchFilter button */}
            <div className={`booking-pitch-filter-m-wrapper${togglePitchFilter ? ' m-show' : ''}`}>
                <div className='booking-pitch-filter-m-close-btn-wrapper' onClick={() => onTogglePitchFilter()}>
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <path d="M32 4.03186L27.9681 0L16.0116 11.9566L4.03186 0L0 4.03186L11.9566 16.0116L0 27.9681L4.03186 32L16.0116 20.0434L27.9681 32L32 27.9681L20.0434 16.0116L32 4.03186Z" fill="#1E1E1E" />
                    </svg>
                </div>

                <div className='booking-pitch-filter-m-title-wrapper'>
                    <h4 className='booking-pitch-filter-m-title mb'>filter</h4>
                    <h4 className='booking-pitch-filter-m-title'>pitch type</h4>
                </div>
                <h5 className='booking-pitch-filter-m-sub-title'>pitch type</h5>

                <div className='booking-pitch-filter-m-items-wrapper'>
                    {pitchFilterList.map((pitchFilterItem, i) => {
                        return (<div className='booking-pitch-filter-m-item' key={i}>
                            <h4 className='booking-pitch-filter-m-item-label'>{pitchFilterItem.label}</h4>
                            <div className='booking-pitch-filter-m-item-checkbox-wrap' onClick={() => onPitchFilterChange(i)}>
                                {selectedPitchType === pitchFilterItem.name ?
                                    <svg className='booking-pitch-filter-m-item-checkbox-icon' width="34" height="34" viewBox="0 0 162 162" fill="none">
                                        <g id="Group">
                                            <path id="Vector" d="M132.319 0H29.6772L0 29.6772V132.319L29.6772 161.933H132.319L161.933 132.319V29.6772L132.319 0Z" fill="#DAFF00" />
                                            <path id="Vector_2" d="M123.687 44.5474H115.243L65.4032 94.3875L46.8156 75.7368H38.2463L33.0796 80.9036V89.3468L61.1186 117.386H69.6248L128.664 58.2203L128.727 56.9602C128.79 54.6288 128.79 53.3056 128.79 51.0373V49.7141L123.687 44.5474Z" fill="#282727" />
                                        </g>
                                    </svg> :
                                    <svg className='booking-pitch-filter-m-item-checkbox-icon' width="34" height="34" viewBox="0 0 34 34" fill="none">
                                        <g id="Group 131">
                                            <path id="Vector" d="M27.7592 0H6.25409L0 6.25409V27.7592L6.25409 34H27.7592L34 27.7592V6.25409L27.7592 0ZM8.34762 28.9119L5.08808 25.6524V8.34762L8.34762 5.08808H25.6391L28.8987 8.34762V25.6391L25.6391 28.8987H8.34762V28.9119Z" fill="#000000" />
                                        </g>
                                    </svg>
                                }
                            </div>
                        </div>);
                    })}
                </div>

            </div>
        </div>
    )
}

export default Booking;


// booking basket block
function BookingBasket({ myBasket, onRemoveToBasket, onCheckout, isCheckoutRequestAlive, musicStudioSubAssetsConfig }) {

    return (<>
        <div className='booking-basket-items'>
            {myBasket.list?.map((basketItem, i) => {
                return <div className='booking-basket-item' key={i}>
                    {basketItem.type === "MUSIC_STUDIO" ? <>
                        <div className='booking-basket-item-detail'>{`${basketItem?.name} //`}</div>
                        <div className='booking-basket-item-detail'>
                            {`${musicStudioSubAssetsConfig?.[basketItem?.assetId]?.assetType?.replaceAll('_', ' ')} //`}
                        </div>
                        <div className='booking-basket-item-detail'>
                            {`${musicStudioSubAssetsConfig?.[basketItem?.assetId]?.name} //`}
                        </div>
                        <div className='booking-basket-item-detail'>
                            {`£${basketItem?.price} X ${basketItem?.peopleCount}(Seat${basketItem?.peopleCount > 1 ? 's' : ''}) //`}
                        </div>
                    </> : <>
                        <div className='booking-basket-item-detail'>{`${basketItem?.previewDate} //`}</div>
                        <div className='booking-basket-item-detail'>{`${basketItem?.startHs}:${basketItem?.startMs}-${basketItem?.endHs}:${basketItem?.endMs} //`}</div>
                        <div className='booking-basket-item-detail'>{`${basketItem?.name} //`}</div>
                    </>}
                    {basketItem.type === "GAMES_ROOM" && <div className='booking-basket-item-detail'>
                        {`£${basketItem?.price} X ${basketItem?.consoleCount}(Console${basketItem?.consoleCount > 1 ? 's' : ''}) //`}
                    </div>}
                    <div className='booking-basket-item-action-wrapper'>
                        {['GAMES_ROOM', 'MUSIC_STUDIO'].includes(basketItem.type) ?
                            <div className='booking-basket-item-price'>
                                {basketItem.type === "MUSIC_STUDIO" ? `£${basketItem?.price * basketItem?.peopleCount}` : `£${basketItem?.price * basketItem?.consoleCount}`}
                            </div>
                            : <div className='booking-basket-item-price'>{`£${basketItem?.price}`}</div>
                        }
                        <div className='booking-basket-item-remove' onClick={() => onRemoveToBasket(i)}>x remove</div>
                    </div>
                </div>
            })}

            {!myBasket.list?.length && <div className='booking-basket-item'>
                <div className='booking-basket-empty-box'>
                    <h4 className='booking-basket-empty-box-msg'>your basket is empty.</h4>
                </div>
            </div>}

        </div>

        {(myBasket?.list?.length > 0) && <>
            <div className='booking-basket-footer-wrapper'>
                <div className='booking-basket-totals'>
                    <h4 className='booking-basket-total-title'>Total</h4>
                    <h4 className='booking-basket-total-price'>{`£${myBasket?.total}`}</h4>
                </div>

                <div className='booking-basket-divider'></div>

                <div className='booking-basket-action-wrapper'>
                    <button type='button' className={`booking-basket-action-btn${isCheckoutRequestAlive ? ' disabled' : ''}`}
                        onClick={onCheckout} disabled={isCheckoutRequestAlive}>
                        <h4 className='booking-basket-action-btn-text'>checkout</h4>
                    </button>
                </div>
            </div>
        </>}
    </>);
};


// component to show the venue hire room details
function VenueHireRoom({ loadFor, onVenueEnquire, onDownloadBrochure }) {

    const [currentIndex, setCurrentIndex] = useState(0);
    if (!_VENUE_HIRE_DATA?.hasOwnProperty(loadFor)) {
        return <></>;
    }

    const roomRata = _VENUE_HIRE_DATA[loadFor];
    const images = roomRata.gallery;
    const tableData = roomRata.table;

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };
    const prevSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    return (<div className="venue-hire-section-container">
        <div className="slider-wrapper">
            <picture>
                {images[currentIndex].list.map((source, index) => <source key={index} media={source.media} srcSet={source.srcset} />)}
                <img className="slide-image" src={images[currentIndex].default} alt={`Slide ${currentIndex}`} />
            </picture>
            {/* Left Arrow */}
            <button className="prev-next-btn prev-btn" onClick={prevSlide}>
                <svg width="11" height="14" viewBox="0 0 11 14" fill="none" className='np-icon'>
                    <path d="M10.8957 0.709961L9.62438 0.709961L0.734375 5.9627L0.734375 8.0357L9.58844 13.2906H10.8957V11.5656L3.09276 7.00028L10.8957 2.43277V0.709961Z" fill="black" />
                </svg>
            </button>

            {/* Right Arrow */}
            <button className="prev-next-btn next-btn" onClick={nextSlide}>
                <svg width="11" height="14" viewBox="0 0 11 14" fill="none" className='np-icon'>
                    <path d="M0.646327 13.29L1.91761 13.29L10.8076 8.0373L10.8076 5.9643L1.95355 0.709395L0.646327 0.709395L0.646327 2.43437L8.44923 6.99972L0.646327 11.5672L0.646327 13.29Z" fill="black" />
                </svg>
            </button>
        </div>

        <div className='venue-room-detail-container'>
            <div className='venue-room-detail-wrap'>
                <h2 className='venue-room-name'>{roomRata?.title}</h2>
                <p className='venue-room-description'>{roomRata?.description}</p>
                <div className='button-group'>
                    <button className='venue-action-button' onClick={onVenueEnquire}>enquiry now</button>
                    <button className='venue-action-button' onClick={onDownloadBrochure}>Download Brochure</button>
                </div>
            </div>

            <div className='grid-table-wrap'>
                <div className="grid-table">
                    {tableData && tableData.map((row, rowIndex) => (
                        <div className='row-col-group' key={rowIndex}>
                            <div className='th-cell'>
                                <span className='th-cell-text'>{row.title}</span>
                            </div>
                            {row?.values?.map((value, colIndex) => (
                                <div key={colIndex} className={('td-cell' + (!value ? ' empty-cell' : ''))}>
                                    {value && <span className='td-cell-text'>{value}</span>}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </div>)
}


// component to reuse the slider for music studio and venue hire
function CommonSlider({ gallery }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const images = [...gallery];

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };
    const prevSlide = () => {
        setCurrentIndex((prevIndex) => prevIndex === 0 ? images.length - 1 : prevIndex - 1);
    };

    return (<div className="slider-wrapper">
        {images.map((image, pIdx) =>
            <picture key={pIdx} style={currentIndex !== pIdx ? { 'display': 'none' } : {}}>
                {image.list.map((source, index) => (
                    <source key={`${pIdx}${index}`} media={source.media} srcSet={source.srcset} />
                ))}
                <img src={image.default} alt={`Slide ${currentIndex}`} className="slide-image" />
            </picture>
        )}
        {/* Left Arrow */}
        { images.length <= 1 ? null :
            <button className="prev-next-btn prev-btn" onClick={prevSlide}>
                <svg width="11" height="14" viewBox="0 0 11 14" fill="none" className='np-icon'>
                    <path d="M10.8957 0.709961L9.62438 0.709961L0.734375 5.9627L0.734375 8.0357L9.58844 13.2906H10.8957V11.5656L3.09276 7.00028L10.8957 2.43277V0.709961Z" fill="black" />
                </svg>
            </button>
        }

        {/* Right Arrow */}
         { images.length <= 1 ? null :
            <button className="prev-next-btn next-btn" onClick={nextSlide}>
                <svg width="11" height="14" viewBox="0 0 11 14" fill="none" className='np-icon'>
                    <path d="M0.646327 13.29L1.91761 13.29L10.8076 8.0373L10.8076 5.9643L1.95355 0.709395L0.646327 0.709395L0.646327 2.43437L8.44923 6.99972L0.646327 11.5672L0.646327 13.29Z" fill="black" />
                </svg>
            </button>
        }
    </div>)
}


// component to show the music studio details
function MusicStudioSection({ pageContent, children }) {
    const gallery = pageContent.gallery;

    return (<div className="music-studio-section-container">
        <CommonSlider gallery={gallery}></CommonSlider>

        <div className='music-studio-section-content'>
            <div className='music-class-details'>
                <h2 className='music-class-name'>{pageContent?.title}</h2>
                <p className='music-studio-description'>{pageContent?.description}</p>
                {React.Children.count(children) > 0 && <>
                    <div className='button-group'>
                        {/* Render the children here */}
                        {children}
                    </div>
                </>}
            </div>
        </div>
    </div>)
}


function CheckboxIcon({ isChecked, classNames }) {
    if (isChecked) {
        return (<svg className={classNames} width="34" height="34" viewBox="0 0 162 162" fill="none">
            <g id="Group">
                <path id="Vector" d="M132.319 0H29.6772L0 29.6772V132.319L29.6772 161.933H132.319L161.933 132.319V29.6772L132.319 0Z" fill="#DAFF00" />
                <path id="Vector_2" d="M123.687 44.5474H115.243L65.4032 94.3875L46.8156 75.7368H38.2463L33.0796 80.9036V89.3468L61.1186 117.386H69.6248L128.664 58.2203L128.727 56.9602C128.79 54.6288 128.79 53.3056 128.79 51.0373V49.7141L123.687 44.5474Z" fill="#282727" />
            </g>
        </svg>);
    }

    return (<svg className={classNames} width="34" height="34" viewBox="0 0 34 34" fill="none">
        <path d="M27.7592 0H6.25409L0 6.25409V27.7592L6.25409 34H27.7592L34 27.7592V6.25409L27.7592 0ZM8.34762 28.9119L5.08808 25.6524V8.34762L8.34762 5.08808H25.6391L28.8987 8.34762V25.6391L25.6391 28.8987H8.34762V28.9119Z" fill="#282727" />
    </svg>);
}